/**
 * Converts an ISO date string to a custom format.
 *
 * @param {string} isoDate - The ISO date string to be formatted.
 * @return {string} The formatted date string.
 */
export const formatDateToCustomFormat = (isoDate: string): string => {
  if (!isoDate) return "";

  const options: Intl.DateTimeFormatOptions = {
    day: "numeric",
    month: "short",
    year: "numeric",
  };
  const formattedDate = new Date(isoDate).toLocaleDateString(
    undefined,
    options
  );
  return formattedDate;
};

export const addDays = (date: Date, days: number) => {
  const newDate = new Date(date);
  newDate.setDate(date.getDate() + days);
  return newDate;
};

export const formattedTime = (time: string) => {
  //console.log("formattedTime", time, time.replace(/:\d{2} /, " "));
  return time?.replace(/:\d{2} /, " ") || "";
}; // Removes seconds


export const removeSecondsFromDateTime = (datetime: string): string => {
  if (!datetime) return "";
  return datetime.replace(/(\d{2}:\d{2}):\d{2}/, "$1");
};

export const differenceInDays = (end: Date, start: Date): number => {
  const diff = (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24);
  return Math.round(diff);
};

export const dateSortComparator = (v1: any, v2: any) => {
  if (v1 === "N/A" && v2 === "N/A") return 0;
  if (v1 === "N/A") return 1;
  if (v2 === "N/A") return -1;

  const parseDate = (dateStr: string) => {
    const [datePart, timePart] = dateStr.split(" ");
    const [month, day, year] = datePart.split("/");
    const [hours, minutes, seconds] = (timePart || "00:00:00").split(":");

    return new Date(
      parseInt(year, 10),
      parseInt(month, 10) - 1,
      parseInt(day, 10),
      parseInt(hours, 10),
      parseInt(minutes, 10),
      parseInt(seconds, 10)
    ).getTime();
  };

  try {
    const date1 = parseDate(v1);
    const date2 = parseDate(v2);
    return date1 - date2;
  } catch (error) {
    console.error("date sort compare failed:", error);
    return 0;
  }
};

export const isoDateSortComparator = (v1: any, v2: any): number => {
  const isEmpty = (x: any) => x == null || x === "";
  if (isEmpty(v1) && isEmpty(v2)) return 0;
  if (isEmpty(v1)) return 1;
  if (isEmpty(v2)) return -1;

  const t1 = new Date(v1).getTime();
  const t2 = new Date(v2).getTime();
  if (Number.isNaN(t1) && Number.isNaN(t2)) return 0;
  if (Number.isNaN(t1)) return 1;
  if (Number.isNaN(t2)) return -1;
  return t1 - t2;
};
